import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import {MatCardModule} from '@angular/material/card';
import {MatButtonModule} from '@angular/material/button';
import  { UtilsService } from '../../@services/utils.service';
import { ToastService } from '../../@services/toast.service';
import { AuthService } from '../../@services/auth.service';
import { environment as env } from '../../../environments/environment';

@Component({
  selector: 'app-utilities',
  imports: [CommonModule, FormsModule, MatCardModule, MatButtonModule],
  templateUrl: './utilities.component.html',
  styleUrl: './utilities.component.scss'
})
export class UtilitiesComponent {

  constructor(
    private utilsService: UtilsService,
    private toast: ToastService,
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  fingerprints_data: string[] = [];
  onFingerprintsFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const text = e.target.result;
        this.parseFingerprintsCsvData(text);
      };
      reader.readAsText(file);
    }
  }
  parseFingerprintsCsvData(data: string) {
    const lines = data.split('\n');
    //Sanitize lines
    for (let i = 0; i < lines.length; i++) {
      //Remove return characters and trim whitespace
      lines[i] = lines[i].replace(/\r/g, '').trim();

      //Remove double quotes if present
      if (lines[i].startsWith('"') && lines[i].endsWith('"')) {
        lines[i] = lines[i].substring(1, lines[i].length - 1);
      }

      //Remove empty lines
      if (lines[i] === '') {
        lines.splice(i, 1);
        i--;
      }
    }
    // console.log('Parsed Fingerprints:', lines);
    this.fingerprints_data = lines;
  }
  async onUploadFingerprintsClick() {
    let res = await this.utilsService.upload_fingerprints_data(this.fingerprints_data);
    if (res?.err) {
      const viaErr = res.upstream ? ` (via ${res.upstream})` : '';
      this.toast.error(`Error uploading alerts to Fingerprints DB${viaErr}: ${res.err}`);
      return;
    }
    console.log(res);
    if (res?.success) {
      // res.upstream comes from the f2-admin-service forwarder so the
      // operator sees which per-product service actually wrote the data
      // (today: optionpit-svc.f2-tech.ai). When the hostname migrates
      // off customer-name DNS, the toast updates automatically.
      const via = res.upstream ? ` via ${res.upstream}` : '';
      this.toast.success(`Successfully uploaded ${this.fingerprints_data.length} alerts to Fingerprints DB${via}.`);
      this.fingerprints_data = [];
    }
  }

  // Change own password — calls /rest/user/settings/change-password on
  // the new backend endpoint. The authenticated user's email comes from
  // ctx.userData on the server (validated f2_id cookie); the body
  // cannot specify a different user.
  newPassword: string = '';
  confirmNewPassword: string = '';
  changingPassword = false;

  can_change_password(): boolean {
    return !this.changingPassword
      && !!this.newPassword
      && this.newPassword.length >= 8
      && this.newPassword === this.confirmNewPassword;
  }

  async on_change_password() {
    if (!this.can_change_password()) return;
    this.changingPassword = true;
    try {
      const res: any = await this.http
        .post(
          `${env.apiUrl}/rest/user/settings/change-password`,
          { newPassword: this.newPassword },
          { withCredentials: true },
        )
        .toPromise();
      if (res?.success) {
        this.toast.success('Password updated — signing you out.');
        this.newPassword = '';
        this.confirmNewPassword = '';
        // Backend cleared the auth cookies on this response. Force a
        // fresh sign-in so the user can confirm the new password works
        // and so the old (still-valid-until-exp) JWT in any other tab
        // doesn't keep a stale session alive. Bounce to Cognito with
        // prompt=login. Brief delay so the success toast renders.
        setTimeout(() => this.authService.logout(), 800);
      } else {
        this.toast.error(res?.err || 'Password change failed.');
      }
    } catch (e: any) {
      const msg = e?.error?.message || e?.message || 'Password change failed.';
      this.toast.error(msg);
    } finally {
      this.changingPassword = false;
    }
  }
}
